export class FaxDto {
  countryCode: string;
  faxPrefix: string;
  faxNumber: string;

  public constructor(init?: Partial<FaxDto>) {
    Object.assign(this, init);
  }
}
